import {
  Group,
  Stack,
  Title,
} from '@mantine/core'
import StatusPill from 'app/views/pages/deals-management/common/pill-status'
import { LoanParams } from 'app/models/loan-params'


interface props {
  loan: LoanParams,
  customTitle?: string
  showStatusPill?: boolean
}

export default function LoanHeader({ loan, customTitle, showStatusPill=true }: props): JSX.Element {
  return (
    <Stack className="detailsHeader">
      <Group noWrap>
        {customTitle ?
          <Title className='detailsTitle'>{customTitle}</Title> :
          <Title className='detailsTitle'>{loan ? loan.amount : ''}</Title>}
        {showStatusPill && (<StatusPill
          updated={true}
          state={loan?.status ?? 'Draft'}
        />)}
      </Group>
    </Stack>
  )
}
